import { REGIONS, ENVS, Colors } from '@adsk/bim360-matrix-react-helpers/es/consts';

export const COST_ENV_CONFIG_KEYS = {
  COST_BE: 'COST_BE',
  COST_FE: 'COST_FE'
};

const US_CONFIG = {
  [ENVS.DEV]: {
    [COST_ENV_CONFIG_KEYS.COST_BE]: 'https://developer-stg.api.autodesk.com/cost-dev',
    [COST_ENV_CONFIG_KEYS.COST_FE]: 'https://cost.b360-dev.autodesk.com'
  },
  [ENVS.QA]: {
    [COST_ENV_CONFIG_KEYS.COST_BE]: 'https://developer-stg.api.autodesk.com/cost-qa',
    [COST_ENV_CONFIG_KEYS.COST_FE]: 'https://cost.b360-qa.autodesk.com'
  },
  [ENVS.STAGING]: {
    [COST_ENV_CONFIG_KEYS.COST_BE]: 'https://developer-stg.api.autodesk.com/cost',
    [COST_ENV_CONFIG_KEYS.COST_FE]: 'https://cost.b360-staging.autodesk.com'
  },
  [ENVS.PROD]: {
    [COST_ENV_CONFIG_KEYS.COST_BE]: 'https://developer.api.autodesk.com/cost',
    [COST_ENV_CONFIG_KEYS.COST_FE]: 'https://cost.b360.autodesk.com'
  }
};

export const ENV_CONFIGS = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: {
    [ENVS.DEV]: US_CONFIG[ENVS.DEV],
    [ENVS.QA]: US_CONFIG[ENVS.QA],
    [ENVS.STAGING]: {
      [COST_ENV_CONFIG_KEYS.COST_BE]: US_CONFIG[ENVS.STAGING][COST_ENV_CONFIG_KEYS.COST_BE],
      [COST_ENV_CONFIG_KEYS.COST_FE]: 'https://cost.b360-staging.eu.autodesk.com'
    },
    [ENVS.PROD]: {
      [COST_ENV_CONFIG_KEYS.COST_BE]: US_CONFIG[ENVS.PROD][COST_ENV_CONFIG_KEYS.COST_BE],
      [COST_ENV_CONFIG_KEYS.COST_FE]: 'https://cost.b360.eu.autodesk.com'
    }
  }
};

export const STATUSES = {
  DRAFT: 'draft',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

export const COST_STATUSES = {
  DRAFT: 'draft',
  OPEN: 'open',
  PRICING: 'pricing',
  PROPOSED: 'proposed',
  APPROVED: 'approved',
  EXECUTED: 'executed',
  REJECTED: 'rejected',
  REVISING: 'revising',
  ACCEPTED: 'accepted'
};

export const COST_STATUS_MAPPING = {
  [COST_STATUSES.DRAFT]: STATUSES.DRAFT,
  [COST_STATUSES.OPEN]: STATUSES.PENDING,
  [COST_STATUSES.PRICING]: STATUSES.PENDING,
  [COST_STATUSES.PROPOSED]: STATUSES.PENDING,
  [COST_STATUSES.APPROVED]: STATUSES.APPROVED,
  [COST_STATUSES.EXECUTED]: STATUSES.APPROVED,
  [COST_STATUSES.REJECTED]: STATUSES.REJECTED,
  [COST_STATUSES.REVISING]: STATUSES.PENDING,
  [COST_STATUSES.ACCEPTED]: STATUSES.PENDING
};

export const STATUS_COLOR_MAPPING = {
  [STATUSES.DRAFT]: Colors.GRAY_DARK,
  [STATUSES.PENDING]: Colors.YELLOW,
  [STATUSES.APPROVED]: Colors.GREEN,
  [STATUSES.REJECTED]: Colors.RED
};
